import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, TextArea, Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const MNCForm = ({ section, type }) => {
	const {
		control,
		getValues,
		formState: { errors },
	} = useFormContext();

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};
	const validateCoordinate = (value, fieldName) => {
		const latitude = getValues(sanitizeKey("LATITUDE"));
		const longitude = getValues(sanitizeKey("LONGITUDE"));

		const isEmpty = (val) =>
			val === "" || val === null || val === undefined;

		if (fieldName === "LATITUDE") {
			if (isEmpty(value)) {
				if (!isEmpty(longitude)) {
					return "LATITUDE is required when LONGITUDE is provided";
				}
				return true;
			}

			const numericValue = Number(value);

			if (numericValue < -90 || numericValue > 90) {
				return "LATITUDE must be between -90.00000 and +90.00000";
			}
		}

		if (fieldName === "LONGITUDE") {
			if (isEmpty(value)) {
				if (!isEmpty(latitude)) {
					return "LONGITUDE is required when LATITUDE is provided";
				}
				return true;
			}

			const numericValue = Number(value);

			if (numericValue < -180 || numericValue > 180) {
				return "LONGITUDE must be between -180.00000 and +180.00000";
			}
		}

		return true;
	};
	const handleCoordinateChange = (e, field) => {
		const value = e?.target?.value ?? "";

		// Allow empty value
		if (value === "") {
			field.onChange("");
			return;
		}

		// Allow:
		// - optional negative sign
		// - maximum 3 integer digits
		// - maximum 5 decimal digits
		const coordinateRegex = /^-?\d{0,3}(\.\d{0,5})?$/;

		if (coordinateRegex.test(value)) {
			field.onChange(value);
		}
	};

	return (
		<>
			{section.sectionName === "Mnc" && (
				<MDBRow className="mt-4">
					{section?.fields?.map((formField, fieldIndex) => (
						<MDBCol
							md="3"
							className="pr-2 mt-3"
							key={`${formField.key}-${fieldIndex}`}
						>
							{formField.dataType === "decimal" && (
								<>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>
									<Controller
										name={
											sanitizeKey(formField.key)
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											// Ensure field is defined before accessing properties
											if (!field) return null; // Return null if field is undefined

											return (
												<Input
													autoFocus={false}
													{...field} // Spread the field props from Controller
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														// Check if field.onChange is available before calling it

														field.onChange(e);
													}}
													value={field?.value ?? ""} // Safely use field.value or fallback to ''
													onKeyDown={(e) => {
														preventScientificNotation(
															e
														);
														// Prevent up and down arrow keys
														if (
															e.key ===
															"ArrowUp" ||
															e.key ===
															"ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) =>
														e.target.blur()
													}
												/>
											);
										}}
									/>
								</>
							)}
						</MDBCol>
					))}
				</MDBRow>
			)}

			{section.sectionName === "Deduction" && (
				<MDBRow className="mt-4">
					{section?.fields?.map((formField, fieldIndex) => (
						<MDBCol
							md="3"
							className="pr-2 mt-3"
							key={`${formField.key}-${fieldIndex}`}
						>
							{formField.dataType === "decimal" && (
								<>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>
									<Controller
										name={
											sanitizeKey(formField.key)
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											// Ensure field is defined before accessing properties
											if (!field) return null; // Return null if field is undefined

											return (
												<Input
													autoFocus={false}
													{...field} // Spread the field props from Controller
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														// Check if field.onChange is available before calling it

														field.onChange(e);
													}}
													value={field?.value ?? ""} // Safely use field.value or fallback to ''
													onKeyDown={(e) => {
														preventScientificNotation(
															e
														);
														// Prevent up and down arrow keys
														if (
															e.key ===
															"ArrowUp" ||
															e.key ===
															"ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) =>
														e.target.blur()
													}
												/>
											);
										}}
									/>
								</>
							)}
						</MDBCol>
					))}
				</MDBRow>
			)}
			{section.sectionName === "Remarks" && (
				<>
					<MDBRow className="mt-4">
						{section?.fields
							?.filter(
								(formField) =>
									formField.dataType === "decimal" &&
									formField.fieldName === "AMOUNT OF CARBON CAPTURE STORAGE"
							)
							.map((formField, fieldIndex) => (
								<MDBCol
									md="4"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>

									<Controller
										name={
											formField.key
												? formField.key.replace("|", "")
												: ""
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											if (!field) return null;

											return (
												<Input
													autoFocus={false}
													{...field}
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														field.onChange(e);
													}}
													value={field?.value ?? ""}
													onKeyDown={(e) => {
														preventScientificNotation(e);

														if (
															e.key === "ArrowUp" ||
															e.key === "ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) => e.target.blur()}
												/>
											);
										}}
									/>
								</MDBCol>
							))}
					</MDBRow>
					<MDBRow className="mt-4">
						{section?.fields
							?.filter(
								(formField) =>
									formField.dataType === "decimal" &&
									(formField.fieldName === "LATITUDE" ||
										formField.fieldName === "LONGITUDE")
							)
							.map((formField, fieldIndex) => (
								<MDBCol
									md="4"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>

									<Controller
										name={
											formField.key
												? formField.key.replace("|", "")
												: ""
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										rules={
											formField.key === "LATITUDE" ||
												formField.key === "LONGITUDE"
												? {
													validate: (value) =>
														validateCoordinate(
															value,
															formField.key
														),
												}
												: undefined
										}
										render={({ field }) => {
											return (
												<>
													<Input
														autoFocus={false}
														{...field}
														className="inputHeight"
														type="number"
														step="0.00001"
														value={field?.value ?? ""}
														onChange={(value) => {
	                                                       
															const newValue = value ?? "";

															if (newValue === "") {
																field.onChange("");
																return;
															}

															if (/^-?\d{0,3}(\.\d{0,5})?$/.test(newValue)) {
																field.onChange(newValue);
															}
														}}
														onKeyDown={(e) => {
															//preventScientificNotation(e);

															if (
																e.key === "ArrowUp" ||
																e.key === "ArrowDown"
															) {
																e.preventDefault();
															}
														}}
														onWheel={(e) => e.target.blur()}
													/>

													{errors[
														formField.key?.replace("|", "")
													] && (
															<div className="pt-2 error">
																{
																	errors[
																		formField.key?.replace("|", "")
																	]?.message
																}
															</div>
														)}
												</>
											);
										}}
									/>
								</MDBCol>
							))}
					</MDBRow>
					<MDBRow className="mt-4">
						{section?.fields
							?.filter(
								(formField) => formField.fieldName === "REMARKS"
							) // Filter to include only the REMARKS field
							.map((formField, fieldIndex) => (
								<MDBCol
									md="12"
									className="pr-2 mt-3"
									key={`${formField.key}-${fieldIndex}`}
								>
									{formField.dataType === "string" &&
										formField.fieldName === "REMARKS" && (
											<>
												<Label
													bold
													name={formField.fieldName}
													className="mb-1"
												/>
												<Controller
													name={
														formField.key
															? formField.key.replace(
																"|",
																""
															) // Clean up the key if necessary
															: ""
													}
													control={control}
													defaultValue={
														type === "Edit"
															? formField.value ||
															null
															: ""
													}
													render={({ field }) => {
														if (!field) return null; // Return null if field is undefined

														return (
															<TextArea
																className="textarea-resize"
																value={
																	field.value
																}
																onChange={
																	field.onChange
																}
															/>
														);
													}}
												/>
											</>
										)}
								</MDBCol>
							))}
					</MDBRow>
				</>
			)}
		</>
	);
};

export default MNCForm;
